
import EDDialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  boldWarningText?: string;
  noCallback?: () => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  warningText?: string;
  yesCallback?: () => void;
}

const BokforderAreYouSureDialog: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <EDDialog
      footerActions={[
        {
          label: 'Nej',
          onClick: () => {
            props.noCallback?.();
            props.setOpen(false);
          },
        },
        {
          label: 'Ja',
          onClick: () => {
            props.yesCallback?.();
            props.setOpen(false);
          },
        },
      ]}
      open={props.open}
      onClose={() => props.setOpen(false)}
      title={props.title}
    >
      <EDTypography bold>{props.boldWarningText}</EDTypography>
      <EDTypography>{props.warningText}</EDTypography>
    </EDDialog>
  );
};

export default BokforderAreYouSureDialog;
